module.exports = __webpack_public_path__ + "img/hadaflogowhite.59c2a7c0.svg";